import React from 'react'
import '../components/Contact.css'



const Contact = () => {
  return (

    <div className="footer-container">
    <h4 >Made By <a className="footer-text" href="https://gauravvpnd.netlify.app/" target="_blank" rel="noopener noreferrer">Gauravvpnd</a></h4>
</div>

    
    
  )
}

export default Contact